import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import BranchOfficeData from "../../data/BranchOfficeData";
import WaiterData from "../../data/WaiterData";
import {waiterDialog} from "../../actions/WaiterDialogActions";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {selectWaiter} from "../../actions/WaiterSelectActions";

class WaiterDialog extends Component {

    constructor() {
        super();

        this.state = {
            waiter: {
                full_name: '',
                phone: '',
                id: null,
                branch_office: {
                    id: '',
                    name: ''
                },
                active: false
            },
            branch_offices: [],
            branch_office_error: false,
            name_error: false,
            sending:  false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.modal) {
            this.setState({waiter: nextProps.modal.waiter});
        }
    }
    handleActive = () => {
        let active = update(this.state, {
            waiter: {
                active: {
                    $set: !this.state.waiter.active
                }
            }
        });
        this.setState(active);
    };

    componentDidMount() {
        this.getBranchOffices();
    }

    async getBranchOffices() {
        let branch_offices = await BranchOfficeData.listAll();
        this.setState({branch_offices})
    }

    handleBranchOfficeChange = (result) => {
        let branch_office = update(this.state, {
            waiter: {
                branch_office: {$set: result}
            }
        });
        this.setState(branch_office);
        this.setState({branch_office_error: false})
    };

    handleFullNameChange = (event) => {
        let name = update(this.state, {
            waiter: {
                full_name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({full_name_error: true})
        } else {
            this.setState({full_name_error: false});
        }
    };

    handlePhoneChange = (event) => {
        let phone = update(this.state, {
            waiter: {
                phone: {
                    $set: event.target.value
                }
            }
        });
        this.setState(phone);
        if (event.target.value.trim() === '') {
            this.setState({phone_error: true})
        } else {
            this.setState({phone_error: false});
        }
    };

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.waiter.full_name === '') {
            this.setState({full_name_error: true});
        } else if (this.state.waiter.phone === '') {
            this.setState({phone_error: true});
        } else if (this.state.waiter.branch_office === '') {
            this.setState({branch_office_error: true});
        } else {
            this.setState({sending: true});
            if (this.state.waiter.id) {
                WaiterData.update(this.state.waiter, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Mesero Actualizado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false, open: false});
                });
            } else {
                WaiterData.add(this.state.waiter, (res) => {
                    if (res !== null) {
                        this.dispatchData(res, 'Mesero Agregado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false, open: false});
                });
            }
        }
    };

    dispatchData = (waiter, message) => {
        this.props.waiterDialog({open:false, waiter:{id:null, full_name:'', phone:'', active:true}});
        this.props.selectWaiter(waiter);
        this.props.showToast({message: message, type: 'success'});
    };

    handleClose = () => {
        this.props.selectWaiter({id:null, full_name:''});
        this.props.waiterDialog({open:false, waiter:{id:null, full_name:'', phone:'', active:true}});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' dimmer='inverted' open={this.props.modal.open} onClose={this.handleClose}>
                    <Modal.Header>{this.props.modal.waiter.id ? 'Actualizar Mesero':'Nuevo Mesero'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input label='Nombre Completo' placeholder='Nombre Completo'
                                                        value={this.state.waiter.full_name}
                                                        onChange={this.handleFullNameChange}
                                                        error={this.state.full_name_error}/>
                                            <Form.Input label='Teléfono' placeholder='Teléfono'
                                                        value={this.state.waiter.phone}
                                                        onChange={this.handlePhoneChange}
                                                        error={this.state.phone_error}/>
                                            <Form.Select label='Sucursal' options={this.state.branch_offices}
                                                         onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                                         value={this.state.waiter.branch_office}
                                                         placeholder='Sucursal' error={this.state.branch_office_error}/>
                                            <Form.Checkbox label='Mesero activo' checked={this.state.waiter.active}
                                                           onChange={this.handleActive}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' labelPosition='left' onClick={this.handleSubmit}
                                content={this.props.modal.waiter.id ? 'Actualizar':'Guardar'}
                                loading={this.state.sending} disabled={this.state.sending}/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('waiter_dialog'),
        waiter_select: state.get('waiter_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        waiterDialog(data) {
            dispatch(waiterDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectWaiter(data){
            dispatch(selectWaiter(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WaiterDialog);



// WEBPACK FOOTER //
// ./src/components/settings/WaiterDialog.js